import { InjectionToken } from '@angular/core';

import { Interceptor, Transport } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';

// Connect-web транспорт с общими для платформы дефолтами и произвольным набором интерсепторов.
// Cookie к cross-site вызовам не прикладываются: сервер их не читает, признак захода идёт
// заголовком, его кладёт перехватчик входа. App-agnostic — конкретные токены/интерсепторы
// собираются в слое приложения.
export function createApiTransport(baseUrl: string, interceptors: Interceptor[] = []): Transport {
    return createConnectTransport({ baseUrl, interceptors });
}

// Транспорт, которым домены приложения говорят с сервером. Токен живёт здесь, а не при домене:
// транспорт один на всё приложение, и объявленный при одном домене он заставлял бы остальные
// зависеть от него ради одного символа.
export const API_TRANSPORT: InjectionToken<Transport> = new InjectionToken<Transport>('API_TRANSPORT');
